// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4af1c9e8","455":"eafbf970","977":"6c40c5a1"}[chunkId] + ".chunk.js";
};